/**
 * Contains functionality to download a certain content from the backend.
 * This common functionality was introduced, as using "location.href=" advises to not work in all browsers.
 * I.e. when Firefox download dialog is shown window.location.href is changed and Firefox closes all open web sockets making DICOM viewer unresponsive (analyzed by Jakub Chalmovsky in SENSE-15554).
 *
 * @packageDocumentation
 */

export function download(url: string): void {
  const downloadLink = document.createElement('a');
  downloadLink.href = encodeURI(url);
  downloadLink.className = 'hidden';
  downloadLink.download = '';
  downloadLink.click();
}
